import { Flame } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

export const StreakBadge = () => {
  const { user } = useAuth();
  const { data } = useQuery({
    queryKey: ["streak", user?.id],
    queryFn: async () => (await api.post("/engagement/ping")).data,
    enabled: !!user,
    staleTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
  if (!user || !data?.current) return null;
  return (
    <span data-testid="streak-badge"
      title={`${data.current}-day reading streak · best ${data.best}`}
      className="inline-flex items-center gap-0.5 font-mono text-xs font-bold text-[#F59E0B] border border-[#F59E0B]/40 rounded-full px-2 py-0.5 select-none">
      <Flame className="h-3.5 w-3.5" /> {data.current}
    </span>
  );
};
